<template>

    <Modal v-model="show"
        title="账号信息"
        :width="60"
        @on-visible-change="onShowChange">
        <Spin v-if="innerSpin"
            size="large"
            fix></Spin>
        <Form ref="userCustomerManagerForm"
            :model="userCustomerManagerForm"
            :rules="ruleValidate"
            label-position="top"
            class="small-form">

            <Row :gutter="18">
                <Col span="6">
                <FormItem label="登录帐号"
                    prop="userName">
                    <Input v-model="userCustomerManagerForm.userName"
                        :readonly="formEditMode===FORM_EDIT_MODE_MODIFY"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="姓名" prop="userCustomerManagerName">
                    <Input v-model="userCustomerManagerForm.userCustomerManagerName"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="所属区域"
                    prop="userCustomerManagerAreaUuid">
                    <Select v-model="userCustomerManagerForm.userCustomerManagerAreaUuid"
                        filterable>
                        <Option v-for="item in areaSource"
                            :key="item.areaUuid"
                            :value="item.areaUuid">{{ item.areaName }}</Option>
                    </Select>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="手机"
                    prop="userCustomerManagerPhone">
                    <Input v-model="userCustomerManagerForm.userCustomerManagerPhone"></Input>
                </FormItem>
                </Col>
            </Row>

            <Row :gutter="18">
                <Col span="6" v-if="formEditMode === FORM_EDIT_MODE_MODIFY">
                <FormItem label="编号" prop="userCustomerManagerCode">
                    <Input v-model="userCustomerManagerForm.userCustomerManagerCode"></Input>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="审批" prop="userCustomerManagerApproval">
                    <RadioGroup v-model="userCustomerManagerForm.userCustomerManagerApproval"
                        type="button">
                        <Radio v-for="item in approvalSource"
                            :key="item.val"
                            :label="item.val">{{ item.label }}
                        </Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="免试资格" prop="userCustomerManagerPassAll">
                    <RadioGroup v-model="userCustomerManagerForm.userCustomerManagerPassAll"
                        type="button">
                        <Radio :label="0">否</Radio>
                        <Radio :label="1">是</Radio>
                    </RadioGroup>
                </FormItem>
                </Col>
                <Col span="6">
                <FormItem label="微信二维码"
                    prop="userCustomerManagerWechatFile">
                    <single-file-upload-with-name v-model="userCustomerManagerForm.userCustomerManagerWechatFile"
                        :imgHeight="150"
                        :imgWidth="150" />
                </FormItem>
                </Col>
            </Row>
            <Row :gutter="18">
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码">
                    <Input v-model="password"
                        type="password"></Input>
                </FormItem>
                </Col>
                <Col v-if="formEditMode === FORM_EDIT_MODE_CREATE"
                    span="6">
                <FormItem label="密码确认">
                    <Input v-model="passwordConfirm"
                        type="password"></Input>
                </FormItem>
                </Col>
            </Row>
        </Form>
		
		<!-- 服务区域 -->
		<div v-if="$checkAccessArray(['S'])&&serviceAreaFormShow" style="margin-top:15px;">
			<Divider orientation="left" size="small">服务区域</Divider>
			<Form :model="serviceAreaForm">
				<Row :gutter="16">
					<Col span="6">
					<FormItem label="服务区域等级" prop="regionGrade">
						<Select v-model="serviceAreaForm.regionGrade" @on-change="onRegionGradeChange">
							<Option v-for="item in regionGradeList" :value="item.val" :key="item.val">{{ item.label }}</Option>
						</Select>
					</FormItem>
					</Col>
				</Row>
				<Row :gutter="18">
					<Col span="6" v-if="serviceAreaForm.regionGrade==1">
					<FormItem label="" prop="provinceUuids">
						<Select v-model="serviceAreaForm.provinceUuids" filterable multiple clearable placeholder="请选择省">
							<Option v-for="item in provinceOptions"
								:key="item.regionUuid"
								:value="item.regionUuid">{{ item.regionName }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="6" v-if="serviceAreaForm.regionGrade==2||serviceAreaForm.regionGrade==3">
					<FormItem label="" prop="provinceUuid">
					    <Select v-model="serviceAreaForm.provinceUuid" filterable clearable placeholder="请选择省" @on-change="onProvinceChange">
					        <Option v-for="item in provinceOptions"
					            :key="item.regionUuid"
					            :value="item.regionUuid">{{ item.regionName }}</Option>
					    </Select>
					</FormItem>
					</Col>
					<Col span="6" v-if="serviceAreaForm.regionGrade==2">
					<FormItem label="" prop="cityUuids">
						<Select v-model="serviceAreaForm.cityUuids" filterable multiple clearable placeholder="请选择市">
							<Option v-for="item in cityOptions"
								:key="item.regionUuid"
								:value="item.regionUuid">{{ item.regionName }}</Option>
						</Select>
					</FormItem>
					</Col>
					<Col span="6" v-if="serviceAreaForm.regionGrade==3">
					<FormItem label="" prop="cityUuid">
					    <Select v-model="serviceAreaForm.cityUuid" filterable clearable placeholder="请选择市" @on-change="onCityChange">
							<Option v-for="item in cityOptions"
							    :key="item.regionUuid"
							    :value="item.regionUuid">{{ item.regionName }}</Option>
					    </Select>
					</FormItem>
					</Col>
					<Col span="6" v-if="serviceAreaForm.regionGrade==3">
					<FormItem label="" prop="regionUuids">
					    <Select v-model="serviceAreaForm.regionUuids" filterable multiple clearable placeholder="请选择区/县">
							<Option v-for="item in distOptions"
							    :key="item.regionUuid"
							    :value="item.regionUuid">{{ item.regionName }}</Option>
					    </Select>
					</FormItem>
					</Col>
					<Col span="6">
						<FormItem label="">
							<Button type="primary" @click="addServiceArea">添加</Button>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="24">
					<Col span="24">
						<FormItem label="服务区域列表">
							<Table ref="regionTable"
								size="small"
								:columns="regionTable.columns"
								:data="serviceAreaList"
								stripe
								border />
						</FormItem>
					</Col>
				</Row>
			</Form>
		</div>
		
        <div slot="footer">
            <Button type="primary" v-if="$checkAccessArray(['S','G'])"
                @click="onSave">确认</Button>
            <Button type="error"
                @click="show=false">取消</Button>
        </div>
    </Modal>
</template>

<script>
import { APPROVAL_NO, APPROVAL_YES, approvalFormat, REGION_GRADE_PROVINCE, REGION_GRADE_CITY, REGION_GRADE_AREA, regionGradeFormat } from '@/libs/baseModelFormat';
import { dateTimeRender } from '@/libs/tableRowTimeRender';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';

import {
    customerManagerUserSave,
    getCustomerManagerUserDetail,
    pageInit4UserCustomerManagerEdit,
    getManagerRegionList,
    addManagerRegion,
    deleteManagerRegion
} from '@/api/modules/account-management/customerManager-user-management';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';

export default {
    name: 'CustomerManagerOutsideUserEdit',
    components: {
        SingleFileUploadWithName
    },
    data() {
        return {
            serviceAreaFormShow: false,
            serviceAreaForm:{
                managerUuid: '',
                regionGrade: 3,
                provinceUuid: '',
                cityUuid: '',
                provinceUuids: [],
                cityUuids: [],
                regionUuids: []
            },
            allRegions: [],
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            serviceAreaList:[],
            show: false,
            innerSpin: false,
            accountUuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            userCustomerManagerForm: {
                userCustomerManagerLoginUuid: '',
                userName: '',
                userCustomerManagerName: '',
                userCustomerManagerAreaUuid: '',
                userCustomerManagerContactNumber: '',
                userCustomerManagerPhone: '',
                userCustomerManagerWechat: '',
                userCustomerManagerEmail: '',
                userCustomerManagerApproval: APPROVAL_NO,
                userCustomerManagerCode: '',
                userCustomerManagerPassAll: 0,
                userCustomerManagerWechatFile: ''
            },
            ruleValidate: {
                userName: [
                    {
                        trigger: 'blur',
                        required: true,
                        validator: (rule, value, callback) => {
                            if (value) {
                                if (value.length >= 3 && value.length <= 20) {
                                    callback();
                                }
                                else {
                                    callback(new Error('长度在3-20个字符之间'));
                                }
                            }
                            else {
                                callback(new Error(' '));
                            }
                        }
                    }
                ],
                userCustomerManagerAreaUuid: [
                    { required: true, message: ' ', trigger: 'blur' }
                ],
                userCustomerManagerPhone: [
                    { pattern:/^(?:(?:\+|00)86)?1\d{10}$/, required: true, message: '手机号码格式不正确 ', trigger: 'blur' }
                ]
            },
            password: '',
            passwordConfirm: '',
            areaSource: [],
            approvalSource: [],
            regionGradeList: [],
            regionTable: {
                columns: [
                    { title: '省份', key: 'provinceName', align: 'center' },
                    { title: '城市', key: 'cityName', align: 'center' },
                    { title: '区县', key: 'areaName', align: 'center' },
                    {
                        title: '服务区域等级',
                        key: 'regionGrade',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, regionGradeFormat(params.row.regionGrade))
                            ]);
                        }
                    },
                    { title: '创建时间', key: 'createTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.createTime) },
                    { title: '更新时间', key: 'modifyTime', align: 'center', render: (h, params) => dateTimeRender(h, params.row.modifyTime) },
                    {
					    title: '操作',
					    key: 'action',
					    align: 'center',
										   width: 120,
					    render: (h, params) => {
					        return h('div', [
					            h('Button', {
					                props: {
					                    type: 'text',
					                    size: 'small'
					                },
					                style: { display: this.$checkAccessArray(['S'])? 'inline-block' : 'none' },
					                on: {
					                    click: () => {
					                        this.deleteManagerRegion(params.row);
					                    }
					                }
                                }, '删除')]);
					    }
                    }
                ]
            }
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        onRegionGradeChange() {
			
        },
        // 添加服务区域
        addServiceArea(){
            let that=this;
            that.innerSpin = true;
            addManagerRegion(that.serviceAreaForm).then(res => {
                that.innerSpin = false;
                if (res.code === 0) {
                    this.$Modal.success({
					    title: '保存服务区域成功',
					    onOk: () => {
					        that.getManagerRegionList(that.accountUuid);
					    }
                    });
                }
            });
        },
        onShowChange(e) {
            if (e) {
                this.init();
            }
        },
        showModal(accountUuid) {
            this.accountUuid = accountUuid;
            this.show = true;
        },
        init() {
            this.approvalSource = [];
            this.approvalSource.push({ val: APPROVAL_NO, label: approvalFormat(APPROVAL_NO) });
            this.approvalSource.push({ val: APPROVAL_YES, label: approvalFormat(APPROVAL_YES) });
			
            this.regionGradeList = [];
            this.regionGradeList.push({ val: REGION_GRADE_PROVINCE, label: regionGradeFormat(REGION_GRADE_PROVINCE) });
            this.regionGradeList.push({ val: REGION_GRADE_CITY, label: regionGradeFormat(REGION_GRADE_CITY) });
            this.regionGradeList.push({ val: REGION_GRADE_AREA, label: regionGradeFormat(REGION_GRADE_AREA) });

            this.innerSpin = true;
            this.getRegionList();
            pageInit4UserCustomerManagerEdit().then(res => {
                this.innerSpin = false;
                if (res.code === 0) {
                    this.areaSource = res.data.area.records.map(item => {
                        return {
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        };
                    });

                    // const query = this.$route.query;
                    if (this.accountUuid) {
                        this.serviceAreaFormShow=true;
                        this.formEditMode = FORM_EDIT_MODE_MODIFY;
                        this.serviceAreaForm.managerUuid=this.accountUuid;
                        getCustomerManagerUserDetail(this.accountUuid).then(detail => {
                            if (detail.code === 0) {
                                const info = detail.data.userCustomerManager;
                                this.userCustomerManagerForm = Object.assign(this.userCustomerManagerForm, info);
								
                            }
                        });
                        this.getManagerRegionList(this.accountUuid);
                    }
                    else {
                        this.serviceAreaFormShow=false;
                        this.serviceAreaList=[];
                        this.$refs.userCustomerManagerForm.resetFields();
                    }
                }
            }).catch(() => {
                this.innerSpin = false;
            });
			
		
        },
        getRegionList(){
            webGetAllRegion().then(res => {
			    if (res.code === 0) {
                    this.allRegions = res.data.allRegions;
                    this.provinceOptions = this.allRegions.filter(r => r.regionType === 1);
                    this.cityOptions = [];
                    this.distOptions = [];
			    }
            });
        },
        onProvinceChange(provinceUuid) {
            this.serviceAreaForm.cityUuids = [];
		    this.serviceAreaForm.regionUuids = [];
		    this.distOptions = [];
		
		    this.serviceAreaForm.cityUuid = '';
		    this.cityOptions = this.allRegions.filter(r => r.regionType === 2 && r.regionParentUuid === provinceUuid);
        },
        onCityChange(cityUuid) {
		    this.serviceAreaForm.regionUuids = [];
		    this.distOptions = this.allRegions.filter(r => r.regionType === 3 && r.regionParentUuid === cityUuid);
        },
        getManagerRegionList(managerUuid){
            this.innerSpin = true;
            getManagerRegionList({ managerUuid:managerUuid }).then(res => {
                this.innerSpin = false;
			    if (res.code === 0) {
                    this.serviceAreaList=res.data.records;
			    }
            });
        },
        deleteManagerRegion(row){
            this.$Modal.confirm({
                title: '是否确认删除该服务区域？',
                onOk: () => {
                    this.innerSpin = true;
                    deleteManagerRegion({
                        managerRegionUuid: row.managerRegionUuid
                    }).then(res => {
                        this.innerSpin = false;
                        if (res.code === 0) {
                            this.getManagerRegionList(row.managerUuid);
                        }
                    });
                }
            });
        },
        onSave() {
            this.$refs.userCustomerManagerForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }

                const data = Object.assign({ formEditMode: this.formEditMode }, this.userCustomerManagerForm);
                if (this.formEditMode === FORM_EDIT_MODE_CREATE) {
                    data.password = this.password;
                    data.passwordConfirm = this.passwordConfirm;
                }
                data.managerType=1;//客户代理
                this.innerSpin = true;
                customerManagerUserSave(data).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$parent.getCustomerManagerUserTableRecords();
                            }
                        });
                    }
                });
            });
        }
    }
};
</script>

<style scoped>
</style>
